'use client';

import { Padding, Typography } from '@musinsa/mds';
import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type BenefitItemProps = {
  title: string;
  subText?: string;
  icon: ReactNode;
  className?: string;
};

export const BenefitItem = ({ title, subText, icon, className }: BenefitItemProps) => (
  <Padding x="4" y="2" className={twMerge('flex gap-12 items-center', className)}>
    <div className="shrink-0">{icon}</div>

    <div className="flex flex-col gap-0.5 flex-1">
      <Typography variant="body14pxMed">{title}</Typography>
      {subText && (
        <Typography variant="body14pxReg" colorScheme="gray-600">
          {subText}
        </Typography>
      )}
    </div>
  </Padding>
);
